export default __webpack_public_path__ + "static/media/stitched.cc93944b.png";